/**
 * Custom hook that provides flags indicating the type of the current institution study.
 *
 * This hook utilizes the `useStore` hook to access the `institutionStore` and determines
 * whether the current institution study type corresponds to "Bright" or "Spirit" using
 * helper functions.
 *
 * @returns An object containing:
 * - `isBright` (boolean): Indicates if the current institution study type is of "Bright" type.
 * - `isSpirit` (boolean): Indicates if the current institution study type is of "Spirit" type.
 *
 * @example
 * const { isBright, isSpirit } = useInstitutionFlags();
 * if (isBright) {
 *   console.log("The institution is of Bright type.");
 * }
 * if (isSpirit) {
 *   console.log("The institution is of Spirit type.");
 * }
 */
import { useStore } from "../../stores/store";
import { isBrightInstitutionType, isSpiritInstitutionType } from "../../utils/helpers/institutionHelper";

export function useInstitutionFlags() {
    const { institutionStore } = useStore();
    const { currentInstitutionStudyType } = institutionStore;
    return {
        isBright: isBrightInstitutionType(currentInstitutionStudyType),
        isSpirit: isSpiritInstitutionType(currentInstitutionStudyType),
    };
}
